import type { TreeMapFilterLocationItem } from "./tree-map-filter-location.type";
import type { AssetTreeNodeGeographyDataType } from "@/entities/asset-tree";

import { useTranslation } from "react-i18next";

import { useTreeMap } from "../tree-map.context";

const FILTERS: AssetTreeNodeGeographyDataType[] = [
  "position",
  "perimeter",
  "area",
];

export const useTreeMapFilterLocation = () => {
  const { t } = useTranslation();
  const { subFilters, toggleSubFilter, setFilterByType } = useTreeMap();

  const activeFilters = subFilters.location?.length ?? 0;

  const filterItems = FILTERS.map((filter): TreeMapFilterLocationItem => {
    return {
      value: filter,
      name: t(`global:treeMap.subFilter.location.${filter}`),
      checked: subFilters.location?.includes(filter),
    };
  });

  const onToggle = (
    subType: AssetTreeNodeGeographyDataType,
    isChecked: boolean
  ) => {
    toggleSubFilter({ type: "location", key: subType });

    // Activate parent filter if needed
    if (!isChecked) setFilterByType("location", true);

    // Desactivate parent filter if last sub-filter is being unchecked
    if (isChecked && activeFilters === 1) setFilterByType("location", false);
  };

  return {
    filterItems,
    onToggle,
  };
};
